module.exports = __webpack_public_path__ + "static/media/46.7ff6ddf3.JPG";